// @ts-nocheck
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import { LinkPresentationProps } from "@insite/mobius/Link";
import setOnePageCheckoutProductListOverlayIsOpen from "@store/Framework/Store/Starter/Components/OnePageCheckoutProductListOverlay/Handlers/SetOnePageCheckoutProductListOverlayIsOpen";
import OrderActionSet, {
    orderActionSetFieldDefinitions,
} from "@store/Library/Components/Toolkit/Order/OrderActionSet";
import { useActiveCartState } from "@toolkit/Framework/Store/Data/Carts/CartsHooks";
import { useOnePageCheckout } from "@toolkit/Framework/Store/Toolkit/Pages/OnePageCheckout/OnePageCheckoutHooks";
import React, { FC } from "react";

const enum fields {
    showViewOrderItems = "showViewOrderItems",
}

export interface OnePageCheckoutActionsProps extends WidgetProps {
    fields: {
        [fields.showViewOrderItems]: boolean;
    };
}

export interface OnePageCheckoutActionsStyles {
    wiewOrderItemsButton?: ButtonPresentationProps;
    wiewOrderItemsLink?: LinkPresentationProps;
}

export const onePageCheckoutActionsStyles: OnePageCheckoutActionsStyles = {
    wiewOrderItemsButton: { variant: "secondary" },
};

const styles = onePageCheckoutActionsStyles;

const OnePageCheckoutActions: FC<OnePageCheckoutActionsProps> = ({
    fields: widgetFields,
}: OnePageCheckoutActionsProps) => {
    const dispatch = useAppDispatch();
    const { cartId } = useOnePageCheckout();
    const { value: cart } = useActiveCartState(cartId);

    const viewOrderItemsHandler = () => {
        dispatch(setOnePageCheckoutProductListOverlayIsOpen({ isOpen: true }));
    };

    return (
        <OrderActionSet
            fields={widgetFields}
            actions={[
                {
                    key: "viewOrderItems",
                    label: translate("View Order Items"),
                    onClick: viewOrderItemsHandler,
                    buttonStyles: styles.wiewOrderItemsButton,
                    linkStyles: styles.wiewOrderItemsLink,
                    testSelector: "wiewOrderItems",
                    field: fields.showViewOrderItems,
                    isDisabled: !cart?.cartLines,
                },
            ]}
        />
    );
};

const widgetModule: WidgetModule = {
    component: OnePageCheckoutActions,
    definition: {
        group: "One Page Checkout",
        allowedContexts: ["OnePageCheckoutPage"],
        displayName: "Actions",
        fieldDefinitions: orderActionSetFieldDefinitions([{ name: fields.showViewOrderItems }]),
    },
};

export default widgetModule;
